import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Observable } from 'rxjs';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { EstatusProyecto } from 'src/app/shared/model/proceso/estadoProyecto';
import {
  OpcionEstatus,
  OportunidadesListaBase,
  VistaOportunidades,
} from '../oportunidades-comun/oportunidades-lista-base';

/** Oportunidades de ODP; pinta la plantilla compartida de Marketing con sus textos y sin alta. */
@Component({
  selector: 'app-oportunidades-odp',
  standalone: true,
  templateUrl: '../oportunidades-marketing/oportunidades-marketing.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    NgxMatSelectSearchModule,
  ],
})
export class OportunidadesODPComponent extends OportunidadesListaBase {
  readonly vista: VistaOportunidades = {
    variante: 'odp',
    titulo: 'Administración de Oportunidades ODP',
    descripcion: 'Revise solicitudes ODP, filtre por cliente o estado y acceda al seguimiento desde la misma tabla.',
    textoSinResultados: 'Ajuste los filtros para consultar otro conjunto de registros.',
    conAlta: false,
    conFiltroEstatus: true,
  };

  override listaEstatus: OpcionEstatus[] = [
    { name: EstatusProyecto.getName(EstatusProyecto.EST_SOL_ODP), val: EstatusProyecto.EST_SOL_ODP },
    { name: EstatusProyecto.getName(EstatusProyecto.EST_SOL_LID), val: EstatusProyecto.EST_SOL_LID },
    { name: EstatusProyecto.getName(EstatusProyecto.REV_ODP), val: EstatusProyecto.REV_ODP },
  ];

  protected readonly rutaSeguimiento = 'PROCESO/seguimiento-oportunidad-odp';

  protected consultaOportunidades(filtro: ConsultaList<Proyecto>): Observable<any> {
    return this.service.getProjectsWithPaginationODP(filtro);
  }
}
